import { useEffect } from 'react';
import isFunction from 'lodash/isFunction';

export const useStreamChannelListener = (channel, event, callback) => {
  useEffect(() => {
    if (!channel || !isFunction(callback)) {
      return;
    }
    const listener = channel.on(event, callback);
    return () => {
      listener.unsubscribe();
    };
  }, [channel]);
};
